module.exports = __webpack_public_path__ + "static/media/not-checked.60d0e5c5.png";